import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getBaseUrl } from "../utils/apiHelper";

const VerifyMagic = () => {
  const location = useLocation();
  const [status, setStatus] = useState(null);
  const [message, setMessage] = useState("Verifying your email...");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const email = params.get("email");
    const code = params.get("code");
    if (!email || !code) {
      setStatus("fail");
      setMessage("Missing email or code in the magic link.");
      return;
    }
    fetch(`${getBaseUrl()}/api/auth/verify-code`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, code })
    })
      .then(async res => {
        const data = await res.json();
        if (res.ok) {
          setStatus("success");
          setMessage("Your email is verified. You can now log in.");
        } else {
          setStatus("fail");
          if (data.message && data.message.toLowerCase().includes("expired")) {
            setStatus("expired");
            setMessage("Verification link expired. Please request a new one.");
          } else if (data.message && data.message.toLowerCase().includes("invalid")) {
            setMessage("Invalid verification link.");
          } else {
            setMessage(data.message || "Verification failed.");
          }
        }
      })
      .catch(() => {
        setStatus("fail");
        setMessage("Verification failed. Please try again later.");
      });
  }, [location.search]);

  return (
    <div className="form-container" style={{textAlign:'center',marginTop:40}}>
      <h2>Email Verification</h2>
      <div style={{fontSize:32, color: status === 'success' ? '#008000' : '#b30000', marginBottom:16}}>
        {status === 'success' ? '✅' : '❌'}
      </div>
      <p style={{color: status === 'success' ? '#008000' : '#b30000', fontWeight:'bold', fontSize:18}}>{message}</p>
    </div>
  );
};

export default VerifyMagic;
